import Link from '../../views/PasswordForgot';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    forgetpassword: email => {
      dispatch(actions.forgetpassword(email)).then(res => {
        //console.log(res);
        //window.close();
        dispatch(push(`/${locale}/passwordforgotmsg`));
      });
    }
  };
};

const PasswordForgot = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default PasswordForgot;



// WEBPACK FOOTER //
// ./src/components/container/PasswordForgot/index.js